export enum FreelancerDrawerTab {
    Profile = 'PROFILE',
    Messages = 'MESSAGES',
}
